import React from 'react';
import Heading from '../../../common/heading/Heading';
import Button from '../../../common/buttons/onboarding/OnboardingButton';
import {
	ONBOARDING_LINK_EXPIRED_TITLE,
	ONBOARDING_LINK_EXPIRED_TEXT,
	ONBOARDING_LINK_EXPIRED_BUTTON,
} from '../../../../constants/Copy';
import { ROUTE_REGISTER } from '../../../../constants/Routes';

export default () => (
	<div className="onboarding-email-verified">
		<Heading>{ONBOARDING_LINK_EXPIRED_TITLE}</Heading>
		<p className="onboarding__text">{ONBOARDING_LINK_EXPIRED_TEXT}</p>
		<Button onClick={ROUTE_REGISTER}>{ONBOARDING_LINK_EXPIRED_BUTTON}</Button>
	</div>
);
